import Image from 'components/gruenland/atoms/image';
import Link from 'components/gruenland/atoms/link';
import Typography from 'components/gruenland/atoms/typography';
import { Tile } from '../../../types';
import { TYPOGRAPHY_MENU_TILE_LABEL } from 'lib/typography';
import { ArrowRightLong } from 'components/gruenland/icons/ArrowRightLong';

export interface Props {
  tileContent: Tile;
}

const HeaderDropdownTile: React.FC<Props> = ({ tileContent }) => {
  return (
    <Link
      variant="primary"
      link={tileContent?.tileLink}
      className="relative h-[440px] w-[340px] overflow-hidden rounded-lg text-neutrals-black"
    >
      <Image
        media={tileContent?.tileImage.media}
        fill
        style={{ objectFit: 'cover' }}
        alt={tileContent?.tileImage.title ?? ''}
      />
      <div className="absolute inset-x-0 bottom-0 flex items-center justify-between p-6">
        <Typography className={TYPOGRAPHY_MENU_TILE_LABEL}>{tileContent?.tileLabel}</Typography>

        <span className="rounded-full bg-white p-[14px]">
          <ArrowRightLong width={20} height={20} />
        </span>
      </div>
    </Link>
  );
};

export default HeaderDropdownTile;
